import type { FrontModule } from "@nabble/sdk";
import { lazy } from "react";

const RadarPage = lazy(() => import("./pages/RadarPage/RadarPage"));
const TenderPage = lazy(() => import("./pages/TenderPage/TenderPage"));
const SourcesPage = lazy(() => import("./pages/SourcesPage/SourcesPage"));

export const tendersModule: FrontModule = {
  id: "tenders",
  version: "0.1.0",
  permission: "tenders.read",
  label: "Tenders",
  icon: "search",
  description:
    "Public technology tenders in Chile — penetration testing, phishing, cyber intelligence, software, DevOps — with what each one asks for.",
  routes: [
    { path: "/tenders", Component: RadarPage },
    { path: "/tenders/sources", Component: SourcesPage },
    { path: "/tenders/:tenderId", Component: TenderPage },
  ],
  menu: [
    {
      id: "tenders.radar",
      label: "Tenders",
      icon: "search",
      path: "/tenders",
      permission: "tenders.read",
      description: "Technology tenders open now and recently closed",
    },
    {
      id: "tenders.sources",
      label: "Sources",
      icon: "globe",
      path: "/tenders/sources",
      permission: "tenders.sources",
      description: "Where tenders come from and how the searches went",
    },
  ],
};

export default tendersModule;
